import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import styles from "../css/resetPassword.module.css";

export default function ResetPassword() {
  return (
    <section className="text-center my-20">
      <Helmet>
        <title>Dailysocialboost | Reset password</title>
      </Helmet>
      <h2 className="text-5xl font-bold my-10">Reset your password</h2>
      <h4 className="font-semibold">Please enter the email address you used when you signed up</h4>
      <form>
        <div className="my-5">
          <div>
            <label className="uppercase font-semibold" htmlFor="email">
              Email Address
            </label>
          </div>
          <input
            placeholder="Email address"
            className={`${styles.resetPassword}`}
            type="email"
            name="email"
            id="email"
            required
          />
        </div>
        <input
          className={`my-5 px-20 py-3 ${styles.resetPasswordInput}`}
          type="submit"
          value="Reset Password"
        />
      </form>
      <Link className="text-pink-350" to="/login">
        Back to Log In
      </Link>
    </section>
  );
}
